export function SameParent(obj1, obj2, obj1IDDef, obj2IDDef, matchCase) {
  var id1 = obj1.GetFieldValue(obj1IDDef);
  if (id1 == null) id1 = "";
  else id1 = id1.toString();
  if (!matchCase) id1 = id1.toLowerCase();

  var id2 = obj2.GetFieldValue(obj2IDDef);
  if (id2 == null) id2 = "";
  else id2 = id2.toString();
  if (!matchCase) id2 = id2.toLowerCase();

  if (id1 == id2) return true;
  else return false;
}
